export default "__VITE_ASSET__CQY9lY8w__"